import { Controller, UseFormReturn } from 'react-hook-form';
import { NumberInput } from '@/schemas/sceneDataSchema';
import { TextField, FormControl } from '@mui/material';
import { encodeFieldKey } from '@/schemas/validation/ValidationSchemaGenerator';

export const InputNumberFormElement = ({ form, component }: { form: UseFormReturn; component: NumberInput }) => {
  return (
    <Controller
      control={form.control}
      name={encodeFieldKey(component)}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          fullWidth
          error={!!error}
        >
          <TextField
            type={'text'} // Changing this to text because it better UI experience
            label={component.label || 'Please enter'}
            variant='outlined'
            fullWidth
            role='textbox'
            error={!!error}
            placeholder={component.label || 'Please enter'}
            helperText={error ? error.message : component.description}
            {...field}
            onChange={(e) => field.onChange(+e.target.value)}
            value={(field.value as number) || ''}
          />
        </FormControl>
      )}
    />
  );
};
